<template>
  <ul class="help">
    <li class="green" v-translate>Vysílání navázaná na pořady</li>
    <li class="orange" v-translate>Vysílání navázaná na pořady, je třeba kontrola</li>
    <li class="red" v-translate>Vysílání navázaná na dočasné pořady</li>
  </ul>
</template>

<script>
export default {
  name: 'description'
}
</script>
